import {ChartI, XyChartI} from "../../Types";

const orderRate: ChartI<XyChartI> = {
    id: "orderRate",
    queryId: "orderRate",
    lang: {
        ua: 'Балів за замовлення'
    },
    type: "xy",
    height: 450,
    parameters: {
        periods: ["Month1", "Month3", "Month6","Year1", "Year2", "Year3", "Year5", "Year7"],
        selectedPeriod: "Year1",
        selectedInterval: "Month1",
        filters: {
            from: {
                lang: {ua: 'З'},
                key: 'from',
                type: 'datetime'
            },
            to: {
                lang: {ua: 'До'},
                key: 'to',
                type: 'datetime'
            }
        }
    },
    settings: {
        usePie: false,
        pieWhole: false,
        usePieNumberLabel: false,
        usePieNumberPercentage: true,
        pieShortNames: {
            count: 'Балів',
        },
        entries: [
            {
                key: 'count',
                lang: {
                    ua: 'Кількість балів'
                }
            }
        ],
        colors: {
            count: '#148aff',
        },
        glyphs: [],
        barType: "bar",
        lineType: "none",
        tooltipGlyphComponent: "🐋"
    }
}

export default orderRate
